import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComboEstadoCivilComponent } from './combo-estado-civil.component';
import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { ComboPesquisavelModule } from '../combo-pesquisavel/combo-pesquisavel.module';



@NgModule({
  declarations: [ComboEstadoCivilComponent],
  imports: [
    CommonModule,
    MaterialCommonModule,
    MatExpansionModule,
    ComboPesquisavelModule
  ],
  exports:[ComboEstadoCivilComponent]
})
export class ComboEstadoCivilModule { }
